import Subscriptions from 'app/collections/subscriptions';
import PaymentMethods from 'app/models/payment_methods';

import Base from 'app/views/base';
import PaymentMethodDetailsView from 'app/components/pages/billing/payment_methods/details_view';

import AccountBalanceView from './account_balance';
import PricePerShipmentView from './price_per_shipment';
import SubscriptionsView from './subscriptions';
import PaymentLogsView from './payment_logs';
import CashFlowView from './cash_flow';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'billing',

  initialize({ user, query = {} }) {
    this.user = user;
    this.paymentMethods = new PaymentMethods({});
    this.subscriptions = new Subscriptions([]);

    this.addSubview('accountBalance', '#account_balance', new AccountBalanceView({
      user: this.user, paymentMethods: this.paymentMethods,
    }));
    this.addSubview('pricePerShipment', '#price_per_shipment', new PricePerShipmentView({
      user: this.user, subscriptions: this.subscriptions,
    }));
    this.addSubview('subscriptions', '#subscriptions', new SubscriptionsView({
      collection: this.subscriptions,
    }));
    this.addSubview('paymentMethods', '#payment_methods', new PaymentMethodDetailsView({
      model: this.paymentMethods, user: this.user,
    }));
    this.addSubview('paymentLogs', '#payment_logs', new PaymentLogsView({
      paymentMethods: this.paymentMethods, user: this.user, query,
    }));
    this.addSubview('cashFlow', '#cash_flow', new CashFlowView({ query }));

    this.paymentMethods.fetch();
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/index.js